import React from 'react';
import { motion } from 'framer-motion';

export const Button = ({ children, variant = 'primary', className = '', ...props }) => {
  const baseStyle = "inline-flex items-center justify-center rounded-full px-6 py-3 text-sm font-semibold transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transform active:scale-[0.98]";

  const variants = {
    primary: "bg-navy-900 text-white hover:bg-navy-800 focus:ring-navy-900 shadow-premium hover:shadow-premium-hover border border-navy-800/50 bg-gradient-to-b from-navy-800 to-navy-900 text-white font-bold",
    secondary: "bg-white text-navy-900 border border-slate-200 hover:border-slate-300 hover:bg-slate-50 focus:ring-slate-200 shadow-sm",
    ghost: "text-slate-600 hover:text-navy-900 hover:bg-slate-50",
    outline: "bg-transparent text-navy-900 border border-navy-900/10 hover:border-navy-900/30 hover:bg-navy-50",
    white: "bg-white text-navy-950 hover:bg-white/95 shadow-xl font-bold border border-white/10 text-navy-950 uppercase tracking-widest text-[11px]",
    navy: "bg-navy-950 text-white hover:bg-navy-900 focus:ring-navy-900 border border-navy-800 shadow-2xl font-bold uppercase tracking-widest text-[11px]"
  };

  return (
    <motion.button 
      whileTap={{ scale: 0.98 }} 
      className={`${baseStyle} ${variants[variant]} ${className}`} 
      {...props}
    >
      {children}
    </motion.button>
  );
};